/**
 * Per-step validation for the course guide.
 * Returns { isValid: boolean, errors: Object }
 */

export const validateStep = (step, guideState, t) => {
  const errors = {};

  switch (step) {
    case 0: // Name & Cover
      if (!guideState.courseName?.trim()) {
        errors.courseName = t('courseGuide.validation.nameRequired');
      }
      break;

    case 1: // TOC Builder
      if (!guideState.tocStructure?.length) {
        errors.tocStructure = t('courseGuide.validation.atLeastOneSection');
      } else {
        const hasPages = guideState.tocStructure.some((s) => s.pages?.length > 0);
        if (!hasPages) {
          errors.tocStructure = t('courseGuide.validation.atLeastOnePage');
        }
      }
      break;

    case 2: // Module Showcase - optional, no required fields
      break;

    case 3: // Settings - optional, no required fields
      break;

    default:
      break;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
